import React from "react";
import { trimString } from "../../../Utils";

const OfflineLinks = () => {
  const links = [
    {
      label: "LINK AADHAR",
      link: "https://eportal.incometax.gov.in/iec/foservices/#/pre-login/bl-link-aadhaar",
    },
    {
      label: "KOTAK BANK",
      link: "https://www.kotak.com/en/personal-banking/accounts/savings-account.html",
    },
    {
      label: "Aadhar Update",
      link: "https://uidai.gov.in/en/my-aadhaar/update-aadhaar.html",
    },
    {
      label: "PUNJAB NATIONAL BANK",
      link: "https://pnbnet.org.in/OOSA/",
    },
    {
      label: "NSDL PAN CARD",
      link: "https://www.onlineservices.nsdl.com/paam/endUserRegisterContact.html",
    },
    {
      label: "E-Shram Card Apply",
      link: "https://register.eshram.gov.in/",
    },
    {
      label: "Aadhaar Download",
      link: "https://myaadhaar.uidai.gov.in/genricDownloadAadhaar",
    },
    {
      label: "AU BANK",
      link: "https://www.aubank.in/personal-banking/savings-account/digital-savings-account",
    },
    {
      label: "BANK OF BARODA",
      link: "https://www.bankofbaroda.in/personal-banking/accounts",
    },
    {
      label: "AXIS BANK",
      link: "https://www.axisbank.com/retail/accounts/savings-account",
    },
  ];
  return (
    <>
      <div className="w-full">
        {links.map((i, index) => (
          <div
            key={index}
            className="grid grid-cols-1 md:grid-cols-2 w-full place-items-start my-3 bg-primary text-white p-3 rounded-md font-semibold cursor-pointer transition-all hover:scale-y-105 "
          >
            <p>{i.label}</p>
            <a
              href={i.link}
              target="_blank"
              style={{ wordBreak: "break-word" }}
              className="decoration-inherit hover:text-white"
            >
              {trimString(i.link, 100)}
            </a>
          </div>
        ))}
      </div>
    </>
  );
};

export default OfflineLinks;
